// import { Link } from "react-router-dom";
// import PageBanner from "../../PageBanner";
// import SocialMediaSidebar from "../../SocialMediaSidebar";
// import SectionHeader from "../../SectionHeader";
// import ScrollToTopButton from "../../ScrollToTopButton";
// import Realtime from "../../../assets/images/realtime.png"
// import CentralizedDashboard from "../../../assets/images/CentralizedManagement.png"

// const OfferingRealTimeParking = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Centralized Management"
//         breadcrumb={[{ label: "Home", href: "/" }, { label: "Offerings" }]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Centralized Management @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/geo-tracking"
//         />
//       </div>

//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Page content */}
//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Summary Section */}
//           <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
//             {/* Text Section */}
//             <div className="md:w-1/2">
//               <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//                 Summary
//               </h4>
//               <p className="text-black mb-4 text-lg">
//                 Centralized management systems revolutionize urban infrastructure by providing complete control of all smart pole devices through a single dashboard. This unified approach enables cities to efficiently monitor and manage VMDs, cameras, Wi-Fi routers, lighting, and environmental sensors across their entire network.
//               </p>
//               <p className="text-black text-lg">
//                 Municipalities implementing centralized smart pole management achieve significant improvements in operational efficiency, maintenance response times, and data-driven decision making while reducing energy consumption and infrastructure costs.
//               </p>
//             </div>

//             {/* Image Section */}
//             <div className="md:w-1/2">
//               <img
//                 src={CentralizedDashboard}
//                 alt="Smart Pole Management Dashboard"
//                 className="w-full h-auto rounded-lg shadow-md"
//               />
//             </div>
//           </div>

//           {/* Introduction Section */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               Introduction
//             </h4>
//             <p className="text-black mb-4 text-lg">
//               Modern smart poles integrate multiple devices and sensors, creating complexity in management. Centralized control systems solve this challenge by providing a unified interface to monitor and control all connected devices across the urban landscape.
//             </p>
//             <p className="text-black text-lg">
//               By connecting all smart pole components to a centralized platform, city operators gain real-time visibility, remote configuration capabilities, and comprehensive analytics for optimized urban infrastructure management.
//             </p>
//           </div>

//           {/* Key Features Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-4 text-black">
//               Key Features of Centralized Smart Pole Management:
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//               <li>
//                 <strong>Unified Device Control:</strong> Manage all connected devices (VMDs, cameras, routers, lighting) from a single interface
//               </li>
//               <li>
//                 <strong>Real-time Monitoring:</strong> Live status updates and alerts for all smart pole components
//               </li>
//               <li>
//                 <strong>Remote Configuration:</strong> Adjust settings and parameters for any device across the network
//               </li>
//               <li>
//                 <strong>Automated Alerts:</strong> Instant notifications for maintenance issues or system failures
//               </li>
//               <li>
//                 <strong>Energy Management:</strong> Monitor and optimize power usage across the entire network
//               </li>
//               <li>
//                 <strong>Data Aggregation:</strong> Collect and analyze data from all connected sensors and devices
//               </li>
//             </ul>
//           </div>

//           {/* Benefits Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-3 text-black">
//               Operational Benefits
//             </h5>
//             <p className="text-black text-lg mb-4">
//               Implementing centralized management delivers measurable improvements:
//             </p>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>40-60% reduction in maintenance response times</li>
//               <li>30-50% improvement in operational efficiency</li>
//               <li>20-35% energy savings through optimized device control</li>
//               <li>Comprehensive data for urban planning and service improvements</li>
//               <li>Reduced operational costs through remote management</li>
//               <li>Enhanced public safety through coordinated device operation</li>
//             </ul>
//           </div>

//           {/* Implementation Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-3 text-black">
//               Implementation Considerations
//             </h5>
//             <p className="text-black text-lg mb-4">
//               Successful deployment requires careful planning:
//             </p>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>
//                 Selection of compatible devices with standardized communication protocols
//               </li>
//               <li>
//                 Network infrastructure capable of handling data from multiple devices
//               </li>
//               <li>
//                 Cybersecurity measures to protect the centralized management system
//               </li>
//               <li>
//                 Staff training for effective use of the management platform
//               </li>
//               <li>Phased implementation starting with pilot zones</li>
//             </ul>
//           </div>

//           {/* Ajeevi's Contribution Section */}
//           <div>
//             <h5 className="text-xl font-semibold mb-3 text-black">
//               Ajeevi's Centralized Smart Pole Management
//             </h5>
//             <p className="text-black mb-4 text-lg">
//               Ajeevi provides comprehensive centralized management solutions:
//             </p>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>
//                 <strong>Unified Control Dashboard:</strong> Intuitive interface for all smart pole devices
//               </li>
//               <li>
//                 <strong>Multi-device Integration:</strong> Supports VMDs, cameras, routers, lighting, and sensors
//               </li>
//               <li>
//                 <strong>Advanced Analytics:</strong> Real-time insights and historical data trends
//               </li>
//               <li>
//                 <strong>Custom Alerts:</strong> Configurable notifications for any device parameter
//               </li>
//               <li>
//                 <strong>Scalable Architecture:</strong> Grows with your smart pole network
//               </li>
//             </ul>
//             <p className="text-black text-lg">
//               Discover how Ajeevi's centralized management can transform your smart pole infrastructure. Visit{" "}
//               <a
//                 href="http://www.ajeevi.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-[#00D084] hover:underline"
//               >
//                 www.ajeevi.com
//               </a>{" "}
//               for more information.
//             </p>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default OfferingRealTimeParking;

import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import Realtime from "../../../assets/images/realtime.png";
import CentralizedDashboard from "../../../assets/images/CentralizedManagement.png";

const OfferingRealTimeParking = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Centralized Monitoring"
        breadcrumb={[{ label: "Home", href: "/" }, { label: "Offerings" }]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Centralized Monitoring @ GyanYantram"
          shareUrl="https://gyanyantram.example.com/monitoring"
        />
      </div>

      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
            {/* Text Section */}
            <div className="md:w-1/2">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                Centralized monitoring with GyanYantram enables real-time oversight and control of all integrated devices such as VMDs, surveillance cameras, Wi-Fi routers, and environmental sensors through a unified dashboard.
              </p>
              <p className="text-black text-lg">
                This centralized approach simplifies infrastructure management, enhances responsiveness, and facilitates data-driven decisions to improve urban efficiency and public safety.
              </p>
            </div>

            {/* Image Section */}
            <div className="md:w-1/2">
              <img
                src={CentralizedDashboard}
                alt="GyanYantram Monitoring Dashboard"
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              GyanYantram’s smart infrastructure integrates multiple technologies and devices, which can be challenging to manage individually. A centralized monitoring platform brings these elements together, allowing unified management and oversight.
            </p>
            <p className="text-black text-lg">
              From a single interface, operators can access live device statuses, configure settings remotely, and gather data analytics to make informed decisions across the entire urban ecosystem.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Centralized Monitoring:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Unified Device Monitoring:</strong> Manage and monitor all GyanYantram devices like VMDs, cameras, sensors, and routers
              </li>
              <li>
                <strong>Live Data Insights:</strong> Real-time status updates and visual alerts
              </li>
              <li>
                <strong>Remote Operations:</strong> Configure and control devices from any location
              </li>
              <li>
                <strong>Alert Automation:</strong> Instant alerts for faults, errors, or thresholds
              </li>
              <li>
                <strong>Energy Control:</strong> Monitor energy use and optimize consumption
              </li>
              <li>
                <strong>Analytics Dashboard:</strong> Consolidated data for decision making
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <p className="text-black text-lg mb-4">
              GyanYantram’s centralized monitoring brings the following benefits:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Faster issue detection and resolution</li>
              <li>Higher operational efficiency across departments</li>
              <li>Reduced manpower and energy costs</li>
              <li>Streamlined urban service management</li>
              <li>Improved public safety and infrastructure reliability</li>
            </ul>
          </div>

          {/* Implementation Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Strategy
            </h5>
            <p className="text-black text-lg mb-4">
              Effective implementation involves:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Integration of standard communication protocols</li>
              <li>Robust and scalable networking setup</li>
              <li>Cybersecurity-enabled system design</li>
              <li>Training for city personnel and operators</li>
              <li>Phase-wise deployment starting from critical zones</li>
            </ul>
          </div>

          {/* GyanYantram's Solution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              GyanYantram's Centralized Monitoring Platform
            </h5>
            <p className="text-black mb-4 text-lg">
              GyanYantram provides a scalable and intelligent platform for centralized device management:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Smart Dashboard:</strong> Easy-to-use interface for all devices
              </li>
              <li>
                <strong>Integrated Devices:</strong> Support for cameras, sensors, VMDs, routers, and lights
              </li>
              <li>
                <strong>Real-time Analytics:</strong> Track events and trends with live data
              </li>
              <li>
                <strong>Custom Alerts:</strong> Set up notifications for specific conditions
              </li>
              <li>
                <strong>Scalability:</strong> Expand the system as the city grows
              </li>
            </ul>
            <p className="text-black text-lg">
              Learn how GyanYantram is transforming urban management through centralized monitoring. Visit{" "}
              <a
                href="http://www.gyanyantram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.gyanyantram.com
              </a>{" "}
              for more details.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingRealTimeParking;
